const HEALTH_RECORD_TYPES = new Set(["manualHealth", "health"]);

const recordIdentity = (record = {}) => (
  record.id
  || record.firebaseId
  || `${record.date || ""}_${record.title || record.name || ""}_${record.fileName || record.documentId || ""}`
);

export const recordsForChild = (child, childRecords = []) => {
  if (!child) return [];
  return childRecords.filter((record) => (
    child.sourceType === "member"
      ? String(record.memberUid || "") === String(child.memberUid || child.id || "")
      : String(record.childId || "") === String(child.id || "")
  ));
};

export const healthRecordsForChild = (child, childRecords = [], healthRecords = []) => {
  const embeddedHealthRecords = recordsForChild(child, childRecords)
    .filter((record) => HEALTH_RECORD_TYPES.has(record.type));

  if (child?.sourceType !== "member") return embeddedHealthRecords;

  const memberUid = String(child.memberUid || child.id || "");
  const memberHealthRecords = healthRecords.filter(
    (record) => String(record.memberUid || "") === memberUid
  );
  const seen = new Set();

  return [...embeddedHealthRecords, ...memberHealthRecords].filter((record) => {
    const identity = recordIdentity(record);
    if (seen.has(identity)) return false;
    seen.add(identity);
    return true;
  });
};

export const childTrackingRecordCount = (child, childRecords = [], healthRecords = []) => {
  const ownRecords = recordsForChild(child, childRecords);
  const nonHealthCount = ownRecords.filter((record) => !HEALTH_RECORD_TYPES.has(record.type)).length;
  return nonHealthCount + healthRecordsForChild(child, childRecords, healthRecords).length;
};

export const totalChildTrackingRecordCount = (children = [], childRecords = [], healthRecords = []) => (
  children.reduce(
    (total, child) => total + childTrackingRecordCount(child, childRecords, healthRecords),
    0
  )
);
